export const DEFAULT_FUNCTION_PREFIX = "microlink.function:";
export const DEFAULT_PROMISE_PREFIX = "microlink.promise:";
